<div class="flex justify-between items-center">
	<div class="flex items-center gap-2">
		<app-icon
			[icon]="ICON.CHECKLIST"
			[testHook]="testHooks.ChecklistIcon"
		></app-icon>
		<p class="text-lg">Checklists</p>
	</div>
	<app-button
		size="small"
		(click)="goToSettings()"
		[testHook]="testHooks.CreateNewButton"
		>Create new</app-button
	>
</div>
<p class="mt-4 font-bold">No checklist assigned</p>
<p class="text-sm text-grey">Select from the list below or create one.</p>
<div class="flex items-center gap-2 mt-2 flex-wrap">
	<app-pill
		*ngFor="let checklist of businessChecklists$ | async"
		mode="secondary"
		size="small"
		class="cursor-pointer"
		(click)="selectChecklist(checklist)"
		[testHook]="testHooks.Pill"
	>
		{{ checklist.title }}
	</app-pill>
</div>
